import { Link } from 'react-router-dom';
import {
  MARKET_MODES,
  MARKET_MODE_STATUS,
  Market
} from '../market';

export const SERVER_PRICE = 9250;

const YANDEX_SEO_PEOPLE_FAQ = [
  {
    title: 'Частые вопросы про поведенческие факторы и SEO Яндекс*',
    isH3: true,
    text:
      <div>
        Что такое «накрутка поведенческих факторов» ПФ через людей?
        <br />
        Это ручное выполнение заданий пользователями, имитирующими естественный интерес по ключевым фразам.
        <br />
        <br />
        Сценарии включают:
        <br />
        <br />
        <ul>
          <li>Поиск по нужной фразе</li>
          <li>Переход на сайт из выдачи,</li>
          <li>Исследование контента: клики, переходы, прокрутка</li>
        </ul>
      </div>
  },
  {
    title: 'Чем это отличается от автоматических ботов?',
    isH3: true,
    text:
      <p>
        Люди принимают решения на основе скриншота и контекста.
        <br />
        <br />
        — Поведение менее предсказуемое и ближе к естественному.
        <br />
        — Результаты можно дополнительно валидировать вручную.
        <br />
        — Такой трафик может использоваться для UX-тестов и фокус-групп.
      </p>
  },
  {
    title: 'Зачем использовать сценарии с людьми для ПФ в Яндексе*?',
    isH3: true,
    text:
      <div>
        Они позволяют:
        <br />
        <br />
        <ul>
          <li>Смоделировать интерес аудитории по ключевым запросам,</li>
          <li>Проверить реакцию на структуру страницы и поведенческие паттерны,</li>
          <li>Получить более органичные сигналы в аналитике.</li>
        </ul>
      </div>
  },
  {
    title: 'Насколько UX-тестирование безопасно для сайта?',
    isH3: false,
    text:
      <ul>
        <li>Платформа не взаимодействует с ранжированием напрямую,</li>
        <li>Все действия прозрачны и отслеживаются в Вебвизоре,</li>
        <li>Вы сами управляете настройками: от времени сессии до глубины просмотра исходя от целий исследования</li>
      </ul>
  },
  {
    title: 'Какой эффект можно ожидать после тестирования взаимодействия?',
    isH3: false,
    text:
      <div>
        Эффект зависит от:
        <br />
        <br />
        <ul>
          <li>Качества сценария и посадочной страницы,</li>
          <li>Конкуренции в нише,</li>
          <li>Регулярности и распределения трафика.</li>
          <li>От внесенных правок на основе ответов от тестировщиков</li>
        </ul>
        <br />
        Это инструмент для тестирования гипотез и поддержки общего продвижения.
      </div>
  },
  {
    title: 'Какие данные видят исполнители?',
    isH3: false,
    text:
      <p>
        Только фраза и изображение сайта в выдаче. Это исключает прямую передачу адреса и делает поведение более органическим.
      </p>
  },
  {
    title: 'Сколько стоит услуги от исполнителей / тестировщиков?',
    isH3: false,
    text:
      <div>
        Стоимость зависит от:
        <br />
        <ul>
          <li>количества исполнителей,</li>
          <li>сложности сценария,</li>
          <li>региона и языка аудитории.</li>
        </ul>
        <br />
        Расчет можно сделать — в калькуляторе на сайте.
      </div>
  },
];

const YANDEX_SEO_BOTS_FAQ = [
  {
    title: 'Что такое поведенческие факторы и зачем они могут быть полезны для сайта?',
    isH3: true,
    text:
        <div>
          <b>Поведенческие факторы</b> — это совокупность сигналов, которые отражают взаимодействие пользователей с сайтом:
          <br />
          <br />
          К ним относятся:
          <br />
          <ul>
            <li>время на сайте,</li>
            <li>глубина просмотра,</li>
            <li>отказные визиты,</li>
            <li>возвращаемость,</li>
            <li>действия внутри страниц.</li>
          </ul>
          <br />
          Эти сигналы могут анализироваться поисковыми системами как часть общей картины сайта. Управление такими сценариями может быть полезно при исследовании поведения пользователей и работе над UX/SEO.
        </div>
  },
  {
    title: 'Чем отличается автоматизированная генерация ПФ от микрозаданий?',
    isH3: false,
    text:
      <div>
        В случае микрозаданий — задания выполняются вручную реальными пользователями.
        <br />
        <br />
        В автоматизированных сценариях — применяются технические агенты (боты), которые действуют согласно заданной логике. 
        <br />
        Такой подход позволяет масштабировать объемы и гибко управлять параметрами:
        <br />
        <br />
        <ul>
          <li>поисковый запрос,</li>
          <li>устройство,</li>
          <li>география,</li>
          <li>время сессии,</li>
          <li>действия на странице.</li>
        </ul>
      </div>
  },
  {
    title: 'Как работает аренда технических агентов для поведенческих факторов?',
    isH3: false,
    text:
      <div>
        <ul>
          Вы задаете сценарий:
          <br />
          <li>поисковую фразу,</li>
          <li>сайт,</li>
          <li>регион,</li>
          <li>особенности поведения.</li>
        </ul>
        <br />
        Затем платформа арендует для вас пул агентов, которые находят сайт через поиск Яндекса и совершают взаимодействия по сценарию.
        <br />
        Это может включать:
        <ul>
          <li>просмотр страниц,</li>
          <li>переходы по ссылкам,</li>
          <li>возвраты,</li>
          <li>выполнение целей, настроенных в Метрике.</li>
        </ul>
      </div>
  },
  {
    title: 'Как быстро можно заметить отклик?',
    isH3: true,
    text:
      <p>
        Реакция может зависеть от множества факторов: конкурентности ниши, текущих позиций сайта, уровня оптимизации и количества привлеченных агентов.
        <br />
        Иногда изменения начинают фиксироваться в течение первых 2–3 суток, но это не гарантирует результат и не связано напрямую с оценкой поисковых систем.
      </p>
  },
  {
    title: 'Сколько стоит аренда персональных технических агентов?',
    isH3: true,
    text:
      <p>
        Цены начинаются от {SERVER_PRICE} рублей.
        <br />
        <br />
        В стоимость входит:
        <br />
        <br />
        <ul>
          <li>аренда серверов,</li>
          <li>использование мобильных прокси,</li>
          <li>инструменты управления поведением,</li>
          <li>инфраструктура для прохождения технических ограничений.</li>
        </ul>
      </p>
  },
  {
    title: 'Как создать проект?',
    isH3: false,
    text:
      <ul>
        <li>Укажите ключевые фразы и регион.</li>
        <li>Прикрепите скриншот заголовка (title) вашего сайта в Яндексе*.</li>
        <li>Выберите количество агентов и желаемую частоту посещений.</li>
        <li>Отслеживайте активность через Метрику и внешние трекеры (например, Топвизор).</li>
      </ul>
  },
  {
    title: 'Какой будет отчет?',
    isH3: false,
    text:
      <p>
        В кабинете Boostclick отображается приблизительное количество визитов, совершенных агентами.
        <br />
        Также можно отслеживать активность через Яндекс* Метрику, Webvisor и SEO-сервисы по позициям (если интегрированы).
      </p>
  },
  {
    title: 'Сколько агентов нужно для эффекта?',
    isH3: false,
    text:
      <p>
        Это зависит от ниши.
        <br />
        Минимальный рекомендуемый объем — от 1000 посещений. 
        <br />
        В конкурентных тематиках может потребоваться больше.
      </p>
  },
  {
    title: 'Нужно ли до запуска проводить SEO-оптимизацию сайта?',
    isH3: false,
    text:
      <p>
        Да.
        <br />
        Без базовой технической оптимизации и релевантного контента поведенческие сценарии могут не дать эффекта.
        <br />
        Платформа предоставляет инструменты, но не заменяет работу с сайтом.
      </p>
  },
];

const YANDEX_SEO_PEOPLE_ARTICLE = {
  title: 'Как надо относиться к поведенческим факторам в 2026 году',
  content: <p>
    Поведенческие факторы играют важную роль в SEO-продвижении сайтов. Они показывают, насколько пользователи действительно взаимодействуют с вашим ресурсом — читают ли тексты, переходят по ссылкам, возвращаются ли на страницы. Яндекс и Google оценивают эти сигналы при ранжировании, поэтому работа с ПФ помогает укрепить позиции в поиске.
    <br />
    <br />
    Накрутка ПФ Яндекс сама по себе не решает все задачи продвижения. Это вспомогательный инструмент, который стоит использовать осознанно и только в рамках общей стратегии SEO. В некоторых случаях поведенческие метрики помогают быстрее выйти в зону видимости, но без качественного контента, грамотной внутренней оптимизации и понятной структуры сайта эффект не закрепится.
    <br />
    <br />
    Чтобы продвижение давало долгосрочный результат, важно сочетать аналитику, технические правки и естественное улучшение взаимодействия пользователей с сайтом. Когда страницы удобны, быстро загружаются и соответствуют запросам аудитории, поисковики это замечают. Поведенческие сигналы усиливают такой эффект, показывая, что ресурс интересен людям, а не просто продвигается искусственно.
    <br />
    <br />
    Если вы рассматриваете накрутку ПФ Яндекс как часть комплексного SEO, обсудите стратегию с опытным специалистом. Он подскажет, где именно требуется улучшить поведенческие метрики, какие страницы нуждаются в проработке и как распределить бюджет эффективно. Такой подход безопасен, не вызывает санкций и помогает добиться стабильного роста позиций даже в конкурентных нишах.
    <br />
    <br />
    Современное SEO — это не гонка за алгоритмами, а системная работа с пользователями и контентом. Когда сайт удобен, полезен и вызывает доверие, любые дополнительные сигналы, включая ПФ, лишь подтверждают для поисковиков его ценность.`
  </p>
};

const STEP_TWO_TITLE_FAQ = <p>
  Почему при добавлении одного действия в калькуляторе появляются
  дополнительные действия?
  <br />
  <br />
  Сервис формирует уникальные сценарии для каждого исполнителя, и каждый
  сценарий начинается для нового исполнителя с поиска товара по сделанному
  скриншоту вашей ссылки.
</p>;

const INFO_HUMANS_ET = <p><b>Источник трафика: Реальные люди</b><br />Более высокая стоимость, но гарантированно качественный результат и долгосрочный эффект. Если от ПФ недостаточно эффекта, то вы можете увеличить объем запросов через ботов. <br /> <Link to="/nakrutka-pf-yandex-bots">Перейти на ботов</Link></p>
const INFO_BOTS_ET = <p><b>Источник трафика: Боты</b><br />Более низкая стоимость.<br /><Link to="/nakrutka-pf-yandex">Перейти на реальных людей</Link></p>

const REAL_ACTIONS = [
  { type: 'ALWAYS.OPEN', icon: "open", iconHome: "home-open", title: 'Открыть поисковик Яндекс', initialShare: 1 },
  { type: 'ALWAYS.SEARCH', icon: "search", iconHome: "home-search", title: 'Набрать поисковый запрос', initialShare: 1 },
  { type: 'ALWAYS.COMPETITORS', icon: "time", iconHome: "home-time", title: 'Открыть несколько сайтов из ТОП-10', titleComment: 'не более 10 сек', initialShare: 1 },
  { type: 'ALWAYS.FIND', icon: "search", iconHome: "home-search", title: 'Найти сайт в поисковой выдаче Яндекса', initialShare: 1 },
  { type: "ALWAYS.CLICK", icon: "click", iconHome: "home-click", title: "Зайти на продвигаемый сайт", initialShare: 1 },
  {
    type: 'EXTRA.DESCRIPTION',
    icon: "time",
    iconHome: "home-time",
    title: 'Изучить меню / каталог / услуги / товар',
    titleComment: 'от 3 мин',
    initialShare: 1,
    activityType: 'Изучение',
  },
  {
    type: 'MAIN.INFO',
    icon: "glasses",
    iconHome: "home-glasses",
    title: 'Почитать информацию о компании',
    initialShare: 1,
    activityType: 'Информация',
  },
  {
    type: 'MAIN.GEO',
    icon: "people",
    iconHome: "home-people",
    title: 'Зайти в адреса / контакты / карту',
    initialShare: 0,
    activityType: 'Контакты',
  },
  {
    type: 'MAIN.PHONE',
    icon: "phone",
    iconHome: '',
    title: 'Копировать номер телефона с сайта',
    titleComment: 'без звонка',
    initialShare: 0,
    activityType: 'Телефон',
  },
  {
    type: 'MAIN.EMAIL',
    icon: "message",
    iconHome: "home-message",
    title: 'Копировать на сайте почту из контактов',
    initialShare: 0,
    activityType: 'Почта',
  },
];

const BOT_ACTIONS = [
  { type: 'ALWAYS.OPEN', icon: "open", iconHome: "home-open", title: 'Открыть поисковик Яндекс', initialShare: 1 },
  { type: 'ALWAYS.SEARCH', icon: "search", iconHome: "home-search", title: 'Набрать поисковый запрос', initialShare: 1 },
  { type: 'ALWAYS.FIND', icon: "search", iconHome: "home-search", title: 'Найти сайт в поисковой выдаче Яндекса', initialShare: 1 },
  { type: "ALWAYS.CLICK", icon: "click", iconHome: "home-click", title: "Зайти на продвигаемый сайт", initialShare: 1 },
  {
    type: 'ALWAYS.DESCRIPTION',
    icon: "time",
    iconHome: "home-time",
    title: '≈ Изучить меню / каталог / услуги / товар',
    titleComment: '≈ 3 мин',
    initialShare: 1,
    activityType: 'Изучение',
  },
  {
    type: 'EXTRA.INFO',
    icon: "glasses",
    iconHome: "home-glasses",
    title: '≈ Почитать информацию о компании',
    initialShare: 1,
    activityType: 'Информация',
  },
  {
    type: 'MAIN.GEO',
    icon: "people",
    iconHome: "home-people",
    title: '≈ Зайти в адреса / контакты / карту',
    initialShare: 1,
    activityType: 'Контакты',
  },
];

const MAIN_PAGE_TITLES = [
  {
    iconHome: "home-action",
    title: "Автоматическое взаимодействие",
    path: '/nakrutka-pf-yandex-bots',
    target: '_self',
    statusForHomePage: MARKET_MODE_STATUS.NEW
  },
  {
    iconHome: "home-action",
    title: "Реальное взаимодействие",
    path: '/nakrutka-pf-yandex',
    target: '_self',
    statusForHomePage: MARKET_MODE_STATUS.NEW
  },
  {
    iconHome: "home-pen",
    title: "Ввести поисковый запрос",
    path: '/nakrutka-pf-yandex',
    target: '_self'
  },
  {
    iconHome: "home-search",
    title: "Найти сайт",
    path: '/nakrutka-pf-yandex',
    target: '_self'
  },
  {
    iconHome: "home-open",
    title: "Открыть Яндекс*",
    path: '/nakrutka-pf-yandex',
    target: '_self'
  },
  {
    iconHome: "home-glasses",
    title: "Изучить сайт",
    path: '/nakrutka-pf-yandex',
    target: '_self'
  },
  {
    iconHome: "home-glasses",
    title: "Изучить компанию",
    path: '/nakrutka-pf-yandex',
    target: '_self'
  },
  {
    iconHome: "home-map",
    title: "Контакты и адрес",
    path: '/nakrutka-pf-yandex',
    target: '_self'
  },
  {
    iconHome: "home-open",
    title: "Зайти на продвигаемый сайт",
    path: '/nakrutka-pf-yandex',
    target: '_self'
  }
];

const STEP_PHRASE_2 = 'Укажите данные, технические агенты выполнят действия по заданной логике';

const YANDEX_SEO_KEYWORDS = ['Yandex', 'yandex', 'Яндекс', 'яндекс' ];

const CHAIN_PRICE_REAL = 24; // изначальная цена
const CHAIN_PRICE_BOTS = 7;

class YandexSeoClass extends Market {

  id = 'yandexseo';

  host = 'yandex.ru';
  url = 'https://www.yandex.ru/';

  title = 'Яндекс*';

  isMarketplace = false;
  isSeo = true;

  icon = "yandex";
  titlePlaces = 'Яндекс*';
  statusForHomePage = MARKET_MODE_STATUS.NEW;
  mainPageTitles = MAIN_PAGE_TITLES;

  chainsPerDayNormal = 42;

  chainsMin = 20;
  chainsMax = 1000;
  chainPrice = CHAIN_PRICE_REAL;

  chainsDefault = 20;

  reviewPrice = 250;

  chainsStep = 10;
  viewsStep = 10;

  keywords = YANDEX_SEO_KEYWORDS;

  targetLinkComment = 'Укажите тут адрес вашего сайта';
  targetLinkCommentShort = 'Укажите сайт';

  modes = [
    {
      id: MARKET_MODES.CHAINS,
      path: '/nakrutka-pf-yandex',
      rating: 0.01,
      title: 'Реальные люди 🙋🙋‍♀️',
      navigateTitle: 'ПФ действия в поисковых системах людьми',
      icon: "lightning",
      iconForHomePage: "home-action",
      status: MARKET_MODE_STATUS.NEW,
      meta: {
        title: `Накрутка ПФ Яндекс в 2026 году — от 1 руб.`,
        description: 'Накрутка ПФ ЛЮДИ в Яндекс — поисковые сценарии, просмотры, взаимодействия.',
        canonical: '/nakrutka-pf-yandex',
      },
      intro: {
        title: 'Накрутка ПФ Яндекс* через тестировщиков',
        comment: 'Протестируйте улучшение ПФ метрик через рекомендации от реальных пользователей:',
        points: [
          'Реальные пользователи выполняют действия по заданным сценариям ↑',
          'Повышается вовлеченность и глубина взаимодействия ↑',
          'Снижается % отказа и растет среднее время сессии ↑',
          'Растет поведенческий сигнал для алгоритмов ↑',
          'Можно отслеживать изменения в аналитике и SEO-сервисах ↑',
        ]
      },
      howItWorks: [
        'Настройте параметры активности в соответствие с конкуренцией',
        'Укажите фразы для поиска вашего сайта',
        'Укажите город и прикрепите скриншот целевой страницы',
        'После оплаты мы передадим исполнителю скриншот и параметры для поиска',
        'Проверьте ответы и активность, примите работу или отправьте на доработку'
      ],
      stepPhrase1: 'Настройте параметры ПФ действий в проекте',
      stepPhrase2: STEP_PHRASE_2,
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: 'Сценарии с участием людей для ПФ Яндекс*↑',
      titleFAQ: "Вопрос-ответ о «накрутке поведенческих факторов» в Яндекс*",
      faq: YANDEX_SEO_PEOPLE_FAQ,
      article: YANDEX_SEO_PEOPLE_ARTICLE,
      actions: (() => {
        return [
          ...REAL_ACTIONS.filter(action => action.type !== 'MAIN.REVIEW' && !action.type.startsWith('VIEW.')),
          ...REAL_ACTIONS.filter(action => action.type === 'MAIN.REVIEW'),
        ];
      })(),
      notice: [
        '* Сервис сгенерирует уникальные цепочки действий с учетом поисковых запросов',
        'Каждый исполнитель получит индивидуальное задание, что гарантирует разное поведение пользователей на вашем сайте',
        'Сложность цепочек и время исполнения зависит от их количества в проекте',
      ]
    },
    {
      id: MARKET_MODES.CHAINS,
      bots: true,
      path: '/nakrutka-pf-yandex-bots',
      rating: 0.01,
      title: 'Боты 🤖',
      navigateTitle: 'ПФ действия в поисковых системах ботами',
      icon: "lightning",
      iconForHomePage: "home-action",
      status: MARKET_MODE_STATUS.NEW,
      meta: {
        title: `Продвижение через ПФ в Яндекс — Боты от 1.25 руб.`,
        description: 'Накрутка ПФ БОТЫ в Яндекс — закажите ботов для поведенческих сценариев.',
        canonical: '/nakrutka-pf-yandex-bots',
      },
      intro: {
        title: 'Аренда технических агентов для SEO-сценариев Яндекс*',
        comment: 'Сценарии с учетом интересов пользователя ПФ и поискового запроса:',
        points: [
          'Визиты по поисковым фразам ↑',
          'Переходы на сайт клиента ↑',
          'Повышение сигнала о вовлеченности и интересе ↑',
          'Настройка под конкретные фразы и категории ↑',
          'Учет интересов ↑',
        ]
      },
      howItWorks: [
        'Настройте параметры активности в соответствие с конкуренцией',
        'Укажите фразы для поиска вашего сайта',
        'Укажите город и прикрепите скриншот целевой страницы',
        'После оплаты мы передадим исполнителю скриншот и параметры для поиска',
        'Проверьте ответы и активность, примите работу или отправьте на доработку'
      ],
      stepPhrase1: 'Настройте параметры действий в проекте',
      stepPhrase2: STEP_PHRASE_2,
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: 'Сценарии с участием ботов для Яндекс*↑',
      titleFAQ: "Вопрос-ответ о «накрутке поведенческих факторов» в Яндекс*",
      faq: YANDEX_SEO_BOTS_FAQ,
      actions: BOT_ACTIONS,
      notice: [
        '* Сервис сгенерирует уникальные цепочки действий с учетом поисковых запросов',
        'Каждый исполнитель получит индивидуальное задание, что гарантирует разное поведение пользователей на вашем сайте',
        'Сложность цепочек и время исполнения зависит от их количества в проекте',
      ],
      chainsStep: 1000,
    },
  ];

  executorTypes = [
    {
      id: 'real',
      title: 'Реальные люди 🙋🙋‍♀️',
      description: INFO_HUMANS_ET,
      chainPrice: CHAIN_PRICE_REAL,
    },
    {
      id: 'bots',
      title: 'Боты 🤖',
      hasPrice: 'от 1 ₽',
      description: INFO_BOTS_ET,
      badge: 'дешевле',
      chainPrice: CHAIN_PRICE_BOTS,
    }
  ];

  actionsMap = REAL_ACTIONS.reduce((map, action) => {
    map[action.type] = action;
    return map;
  }, {});

  emptyUrlStr = 'Укажите ссылку на сайт';
  invalidUrlStr = 'Укажите корректную ссылку на сайт';
}

const YandexSeo = new YandexSeoClass();
export default YandexSeo;
